module.exports = __webpack_public_path__ + "img/444-e9d695.png";